import React from "react"
import classnames from "classnames/bind"
// Style
import imageStyle from "../../style/components/projects/image.module.scss"

export default function Video(props) {
  return pug`
    div.text-center.pt-8(className=classnames(imageStyle.wideImage_wrapper,'md:pt-16',props.className))
      video.mt-6(autoplay="autoplay" loop muted playsinline="playsinline" style={ width: "100%"})
        source(src=props.src type="video/mp4")
      p(className='md:text-base').mt-3.txt-caption.text-sm=props.alt
  `
}
